import React, { useEffect, useState } from "react";
import { Divider, Spin, Tooltip } from 'antd';
import { AiOutlineDownload } from "react-icons/ai";
import CloseIcon from '@mui/icons-material/Close';
import { Refresh } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from "../uiComponent/button/index.js";
import ProgressBar from "../uiComponent/progressBar/index.js";
import { setItem } from "../../slices/auth.js";
import { getLatestFileUpload, markUploadAsSeen } from "../../slices/po.js";

const FileUploadToast = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fileInfo, setFileInfo] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [closedHeader, setClosedHeader] = useState(false);

  const { currentUser, showFileHeader } = useSelector(state => state?.auth || {});
  const { fetchingLatestFileUpload } = useSelector(state => state?.pos || {});

  useEffect(() => {
    dispatch(getLatestFileUpload({
      user_id: currentUser.is_employee_of ? currentUser.is_employee_of : currentUser?.id
    })).then((res) => {
      if (res?.payload?.success && res?.payload?.data) {
        setFileInfo(res?.payload?.data);
        res?.payload?.data?.is_seen && setClosedHeader(true);
      } else {
        setFileInfo({});
      }
    });
  }, [refresh]);

  let status = 'grey';
  if (fileInfo?.success_records === 0 || fileInfo.status === 'inProgress') {
    status = 'grey';
  } else if (fileInfo?.total_records === fileInfo?.success_records) {
    status = 'success';
  } else if (fileInfo?.success_records < fileInfo?.total_records) {
    status = 'warning';
  }

  const closeToast = (fileId) => {
    dispatch(setItem({ field: 'showFileHeader', value: false }));
    dispatch(markUploadAsSeen({ id: fileId }));
    setClosedHeader(true);
  };

  const refreshFile = () => {
    setRefresh((prev) => !prev);
  };

  const shouldShow = (fileInfo?.length !== 0 && !closedHeader) || showFileHeader;

  if (!shouldShow) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 9999,
      background: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
      padding: '12px 16px',
      minWidth: 400,
      maxWidth: 600,
    }}>
      <Spin spinning={fetchingLatestFileUpload}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 12, color: '#0000007D' }}>Name: </span>
            <Tooltip title={fileInfo?.file_name}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#22413C', maxWidth: 80, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{fileInfo?.file_name}</span>
            </Tooltip>
          </div>
          <Divider type="vertical" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 12, color: '#0000007D' }}>Type</span>
            <Tooltip title={fileInfo?.file_type}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#22413C' }}> {fileInfo?.file_type}</span>
            </Tooltip>
          </div>
          <Divider type="vertical" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 12, color: '#0000007D' }}>Status</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: fileInfo?.status === 'inProgress' ? '#F8C859' : 'green' }}>
              {fileInfo?.status ? (fileInfo?.status === 'inProgress' ? 'In Progress' : 'Completed') : ""}
            </span>
          </div>
          <Divider type="vertical" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <ProgressBar
              status={status}
              simpleProgress
              className="header-bar-placement"
              labelText="Packed"
              current={fileInfo.status === 'completed' ? fileInfo?.success_records : '0'}
              total={fileInfo.status === 'completed' ? fileInfo?.total_records : '0'}
              Width={119}
            />
          </div>
          <Divider type="vertical" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Button
              className="file-info-header-btn"
              endIcon={<span style={{
                fontSize: 12, color: '#fff', border: '1px solid #1565D8',
                width: 32, height: 18, borderRadius: 14,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: '#1565D8'
              }}>{fileInfo.status === 'completed' ? (fileInfo?.error_records < 100 ? fileInfo?.error_records : '99+') : '0'}</span>}
              startIcon={<AiOutlineDownload />}
              text='Error'
              onClick={() => navigate('/file-upload-history')}
            />
          </div>
          <IconButton onClick={refreshFile} size="small">
            <Refresh sx={{ color: '#1565D8', fontSize: '16px' }} />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => closeToast(fileInfo.id)}
            sx={{ ml: 'auto' }}
          >
            <CloseIcon fontSize="inherit" sx={{ color: '#999' }} />
          </IconButton>
        </div>
      </Spin>
    </div>
  );
};

export default FileUploadToast;
